import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { EQuestionType, QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { TabularQuestion } from 'src/app/models/TabularQuestion.model';
import { GlobalStore } from 'src/app/store/global-store';
import { EStatus } from 'src/app/models/EnumStatus';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { OptionsListApiService } from 'src/app/features/collections/services/options-list-api.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { DisplayApiFieldNameComponent } from '../../../../question/components/display-api-field-name/display-api-field-name.component';

@Component({
    selector: 'que-question-item',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateDirective, TranslatePipe, OverlayModule, DisplayApiFieldNameComponent],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: QuestionItemComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: QuestionItemComponent,
            multi: true
        }
    ],
    templateUrl: './question-item.component.html',
    styleUrls: ['./question-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionItemComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() isOnly = false;
  @Input() isSmartQuestion?: boolean;
  @Input() apiExposureFieldNameFill?: boolean;
  @Output()
  deleteEvent = new EventEmitter();

  #globalStore = inject(GlobalStore);
  #optionsListApiService$ = inject(OptionsListApiService);
  #questionnaireService = inject(QuestionnaireApiService);

  #builder = inject(FormBuilder);
  modularQuestionForm = this.#builder.group({
    guid: [''],
    type: new FormControl<QuestionType | null>(null),
    title: new FormControl<string>(''),
    optionsListGuid: new FormControl<string | null>(null),
    optionsList: new FormControl<OptionsList | null>(null),
    apiExposureFieldName: new FormControl<string|null>('')
  });
  readonly positonArea = [{
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  }] as ConnectedPosition[];
  types$ = this.#globalStore.questionTypesToModular$;
  typesSig$ = toSignal(this.types$);
  allOptionLists$ = this.#globalStore.optionLists$;
  eStatus = EStatus;
  questionStatus = this.eStatus.unknown;
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;
  typeIdFormControl = new FormControl<number>(0);
  isSelectOpen = false;
  isMainSelectOpen = false;
  selectedType = {} as QuestionType;
  selectedOptionName = "";
  eQuestionType = EQuestionType;

  ngOnInit(): void {
    this.typeIdFormControl.valueChanges.subscribe(
      (typeId) => {
        var type = this.typesSig$()?.find(x => x.id == typeId);
        if (type) {
          this.modularQuestionForm.controls.type.setValue(type)
        }
        this.modularQuestionForm.controls.optionsListGuid.setValue(null);
      }
    );

    this.modularQuestionForm.valueChanges.subscribe(question => {
      // if (this.questionStatus == this.eStatus.Saved) {
      //   this.questionStatus = this.eStatus.Changed;
      // }
      this.registerOnChangeCallback({ ...question, status: this.questionStatus });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.modularQuestionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }

  writeValue(obj: TabularQuestion): void {
    this.questionStatus = obj.status;
    this.typeIdFormControl.setValue(obj.type.id, { emitEvent: false });
    var type = this.typesSig$()?.find(x => x.id == obj.type.id);
    if (type) {
      this.modularQuestionForm.controls.type.setValue(type, { emitEvent: false });
    }
    if (obj.optionsList?.name)
      this.selectedOptionName = obj.optionsList?.name;
    this.modularQuestionForm.patchValue({ ...obj }, { emitEvent: false });
    this.selectedType = obj.type;
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  delete() {
    if (this.questionStatus == this.eStatus.Saved || this.questionStatus == this.eStatus.Changed)
      this.#questionnaireService.deleteTabularQuestionById(this.modularQuestionForm.controls.guid.value ?? '').subscribe(
        x => {

        }
      )
    this.deleteEvent.emit()
  }
  updateSelection(op: OptionsList) {
    this.modularQuestionForm.controls.optionsListGuid.setValue(op.guid);
    this.#optionsListApiService$.getItemsByListId(op.guid).subscribe((x) => {
      this.modularQuestionForm.controls.optionsList.setValue({ ...op, answerOptionItem: x });
    });
    this.selectedOptionName = op.name ?? "";
    this.isSelectOpen = false;
  }
  updateMainSelection(type: QuestionType) {
    this.typeIdFormControl.setValue(type.id);
    this.selectedType = type;
    this.isMainSelectOpen = false;
  }
}
